export default __webpack_public_path__ + "static/media/crystal.17dba665.gltf";